import calculateMapUrl from '../utils/calculateMapUrl';

import { action } from 'satcheljs/lib/legacy';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';
import { trace } from 'owa-trace';

const minBlobSize = 100;
const defaultPhotoWidth = 64;
const defaultPhotoHeight = 64;

/**
 * Download the persona map for the specified place
 * @param viewState: the location persona control view state
 */
function downloadLocationPhoto(viewState: LocationPersonaControlViewState) {
    let photoUrl = '';
    if (
        viewState.postalAddress &&
        viewState.postalAddress.Latitude &&
        viewState.postalAddress.Longitude
    ) {
        photoUrl = calculateMapUrl(
            viewState.postalAddress.Latitude,
            viewState.postalAddress.Longitude,
            defaultPhotoWidth,
            defaultPhotoHeight
        );
    }

    if (!isNullOrWhiteSpace(photoUrl)) {
        let personaBlob = viewState.personaBlob;
        personaBlob.isPendingFetch = true;
        let request = new XMLHttpRequest();
        request.open('GET', photoUrl, true);
        request.responseType = 'blob';
        request.onreadystatechange = function() {
            if (request.readyState === 4) {
                let blob: any = null;
                let isBlob = false;
                if (request.status === 200) {
                    blob = request.response;
                    let contentType = request.getResponseHeader('Content-Type');
                    isBlob =
                        contentType &&
                        contentType.toLowerCase().indexOf('image') == 0 &&
                        blob instanceof Blob;
                }

                <any>action('getLocationPhoto:getLocationPhotoCallback')(() => {
                    if (isBlob && blob && blob.size > minBlobSize) {
                        personaBlob.blobUrl = URL.createObjectURL(blob);
                    } else {
                        personaBlob.hasFetchFailed = true;

                        // Log that we failed to fetch the location photo. Not logging url for now, will add if we see enough number of errors
                        trace.warn('getLocationPhoto.downloadLocationPhoto failed');
                    }
                    personaBlob.isPendingFetch = false;
                })();
            }
        };

        request.send();
    } else if (viewState.personaBlob) {
        viewState.personaBlob.hasFetchFailed = true;
    }
}

/**
 * Action to get the location map
 */
export default action('getLocationPhoto')(function getLocationPhoto(
    viewState: LocationPersonaControlViewState
) {
    if (viewState) {
        let personaBlob = viewState.personaBlob;
        if (
            personaBlob.isPendingFetch ||
            personaBlob.hasFetchFailed ||
            !isNullOrWhiteSpace(personaBlob.blobUrl)
        ) {
            // If it already has a pending request or feth has completed, simply return.
            // when fetch is compteled the blob either have a blobUrl or maked as failed
            return;
        }

        downloadLocationPhoto(viewState);
    }
});
